export default function SpecialGuest() {
  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const credits = [
    { icon: 'ri-tv-fill', title: 'Carrossel', subtitle: 'SBT' },
    { icon: 'ri-netflix-fill', title: '3%', subtitle: 'Netflix' },
    { icon: 'ri-movie-2-fill', title: 'Audiovisual', subtitle: 'Brasileiro' }
  ];

  return (
    <section id="participacao-especial" className="py-16 sm:py-28 lg:py-32 relative overflow-hidden bg-gradient-to-br from-gray-950 via-[#0a0a1a] to-gray-950">
      <div className="absolute top-0 left-0 w-72 h-72 lg:w-[500px] lg:h-[500px] bg-yellow-500/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 lg:w-[600px] lg:h-[600px] bg-yellow-500/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        <div className="text-center mb-10 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full px-4 py-2 mb-5">
            <i className="ri-star-fill text-yellow-500 text-xs"></i>
            <span className="text-yellow-500 text-xs font-semibold tracking-widest uppercase">
              Participação Especial Confirmada
            </span>
            <i className="ri-star-fill text-yellow-500 text-xs"></i>
          </div>
          <h4 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white">
            <a href="#participacao-especial">
              Etapa <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Final</span>
            </a>
          </h4>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center">
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute -inset-4 lg:-inset-8 bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 rounded-3xl blur-2xl"></div>
              <div className="relative w-[260px] h-[340px] sm:w-[340px] sm:h-[440px] lg:w-[420px] lg:h-[540px] rounded-2xl overflow-hidden shadow-2xl shadow-black/60 border border-yellow-500/20">
                <img 
                  alt="Léo Belmonte - Ator brasileiro conhecido por Carrossel SBT"
                  title="Léo Belmonte ator participação especial Four Models"
                  className="w-full h-full object-cover object-top" 
                  src="https://static.readdy.ai/image/103ec5ada18b00c7d95516c6aa3b7243/bcdca41a21e27164614ffcdeaee4e2ad.jpeg"
                />
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent h-32"></div>
              </div>
              <div className="absolute -top-3 -right-3 w-10 h-10 lg:w-14 lg:h-14 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl flex items-center justify-center shadow-lg shadow-yellow-500/30 rotate-6">
                <i className="ri-clapperboard-fill text-black text-lg lg:text-2xl"></i>
              </div>
            </div>
          </div>

          <div className="text-center lg:text-left">
            <div className="flex items-center gap-2 justify-center lg:justify-start mb-2">
              <div className="w-8 lg:w-12 h-[2px] bg-yellow-500"></div>
              <span className="text-yellow-500 text-xs font-semibold tracking-widest uppercase">Convidado Especial</span>
            </div>

            <h3 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black mb-2">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600">
                Léo Belmonte
              </span>
            </h3>

            <p className="text-gray-400 text-sm lg:text-base font-medium mb-6 lg:mb-8 flex items-center justify-center lg:justify-start gap-2">
              <i className="ri-film-fill text-yellow-500/70 text-base"></i>
              Ator • Carrossel (SBT) • 3% (Netflix)
            </p>

            <div className="space-y-4 lg:space-y-5 mb-8 lg:mb-10">
              <p className="text-gray-300 text-sm lg:text-base leading-relaxed">
                Na etapa final da <strong className="text-white">Convenção Four Models</strong>, contaremos com a participação especial do ator <strong className="text-white">Léo Belmonte</strong>, conhecido por interpretar <strong className="text-white">Jorge na novela Carrossel (SBT)</strong>, além de participação na série <strong className="text-white">3%</strong> da Netflix.
              </p>
              <p className="text-gray-300 text-sm lg:text-base leading-relaxed">
                Sua presença reforça o compromisso da <strong className="text-white">Four Models</strong> em proporcionar <strong className="text-yellow-500">experiência real de mercado</strong> e conexão com profissionais atuantes.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-3 lg:gap-4 mb-8 lg:mb-10">
              {credits.map((credit, idx) => (
                <div key={idx} className="bg-white/5 border border-white/10 rounded-xl p-3 sm:p-4 lg:p-5 text-center hover:border-yellow-500/30 transition-all duration-300">
                  <div className="w-8 h-8 lg:w-10 lg:h-10 bg-yellow-500/10 rounded-lg flex items-center justify-center mx-auto mb-2">
                    <i className={`${credit.icon} text-yellow-500 text-sm lg:text-base`}></i>
                  </div>
                  <p className="text-white text-xs lg:text-sm font-semibold">{credit.title}</p>
                  <p className="text-gray-500 text-[11px] lg:text-xs">{credit.subtitle}</p>
                </div>
              ))}
            </div>

            <button onClick={scrollToForm} className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-10 lg:px-14 py-4 lg:py-5 rounded-full text-sm lg:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto">
              QUERO PARTICIPAR
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}